import cloneDeep from 'lodash/cloneDeep';

import type { BaseEntity, BrandCompanyInfo, BrandPrivateInfo } from 'types/brand';

export const getOptions = (optionName: string, optionsArray: Array<BaseEntity>): Array<BaseEntity> => (optionsArray
  ? [...optionsArray, { __typename: optionName, id: null, name: null }]
  : [{ __typename: optionName, id: null, name: null }]);

